import { useQuery } from '@tanstack/react-query';
import { getApiV1Scenarios } from '../api/generated/sdk.gen';
import { useAccessToken } from '../auth/AccessTokenContext';
import { queryKeys } from './queryKeys';

export const useFetchModelScenarios = (modelId: string | undefined) => {
  const token = useAccessToken();

  return useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: queryKeys.modelScenarios(modelId as string),
    queryFn: async () => {
      const response = await getApiV1Scenarios();
      const allScenarios = response.data?.data || [];
      return allScenarios.filter((s) => s.analogue_model_id === modelId);
    },
    enabled: !!token && !!modelId,
  });
};
